module.exports = __webpack_public_path__ + "img/05.3b114d9.png";